var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',_vm._b({ref:"alert",attrs:{"type":"info","text":"","border":"left","transition":"expand-transition"}},'v-alert',Object.assign({}, _vm.$props, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }